module.exports = __webpack_public_path__ + "static/media/16.5a2d8d08.mp3";